import React from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { MediaQueries } from 'core/modules/MediaQueries/MediaQueries';
import ModalProvider from 'core/modules/Modal/ModalProvider';
import PopupProvider from 'core/modules/Popup/PopupProvider';
import StickyFooterVendor from 'core/modules/StickyFooterVendor/StickyFooterVendor';
import ModalRoot from 'core/modules/Modal/ModalRoot';
import PopupRoot from 'core/modules/Popup/PopupRoot';

function Root({ children }) {
  return (
    <MediaQueries>
      <ModalProvider>
        <PopupProvider>
          {children}
          <StickyFooterVendor />
          <ModalRoot />
          <PopupRoot />
        </PopupProvider>
      </ModalProvider>
    </MediaQueries>
  );
}

export default (props) => <ComponentErrorBoundary><Root {...props} /></ComponentErrorBoundary>;
